import { render } from "./Range.vue?vue&type=template&id=4c1d4fcd"
import script from "./Range.vue?vue&type=script&lang=ts"
export * from "./Range.vue?vue&type=script&lang=ts"
script.render = render

export default script